import jwt_decode from 'jwt-decode';
import {fromUnixTime} from 'date-fns';

export default {
  SET_TOKEN(state, token) {
    state.token = token;
    const payload = jwt_decode(token);
    console.log('jwt token:' + JSON.stringify(payload));
    console.log('jwt token exp:' + fromUnixTime(payload.exp).toISOString());

    state.exp = payload.exp;
    state.timeout = null;
    state.claims = payload;

    sessionStorage.setItem('ictp-token', token);
  },

  REDIRECT_TIMER_START(state, token) {
  },

  REDIRECT_TIMER_FINISH(state, token) {
  },

  REMOVE_TOKEN(state) {
    state.token = null;
    state.exp = null;
    state.claims = null;
  }
}
